import React, { useEffect } from "react"
import {
  IoIosArrowBack,
  IoIosCheckboxOutline,
  IoIosRadioButtonOff,
  IoIosRadioButtonOn,
  IoIosSquareOutline,
} from "react-icons/io"
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md"
import { useLocation, useNavigate, useParams } from "react-router-dom"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import { blurKeys } from "@fuse/sharedComponents/blurWrapper/blurKeysList"
import { get, includes } from "lodash-es"
import { ROUTES } from "src/App"

enum QuestionType {
  TEXT = "text",
  LONG_TEXT = "long_text",
  MULTI_SELECT = "multi_select",
  SINGLE_SELECT = "single_select",
}

const ReviewQuestionnaire = () => {
  const { state } = useLocation()
  const { eventId } = useParams()

  const { answersToQuestionnaire, eventDetails, currentTab } = state || {}

  const navigate = useNavigate()

  useEffect(() => {
    if (!state) {
      navigate(ROUTES.EVENTS.replace(":eventId", eventId))
    }
  }, [state])

  const flyerImage = get(eventDetails, "eventDocData.flyerImage", "")

  const handleBackPress = () => {
    // Navigate back and pass the current tab to restore
    navigate(ROUTES.GUEST_LIST.replace(":eventId", eventId), {
      state: {
        restoredTab: currentTab,
      },
    })
  }

  return (
    <BackgroundWrapper bgImage={flyerImage} className="min-h-screen">
      <BlurWrapper
        blurKey={get(blurKeys, "mainBlurView")}
        overlayOpacityDefault="75"
        overlayColorDefault="dark"
        className=" bg-gray-400/10 h-[10vh] flex flex-row  items-center px-6  top-0 left-0 w-full z-10 fixed "
      >
        <div
          className="text-white/30 text-base cursor-pointer p-4 rounded-full bg-white/10 absolute left-6"
          onClick={handleBackPress}
        >
          <IoIosArrowBack className="text-white" />
        </div>
        <div className="text-white text-base cursor-pointer flex-1">
          Questionnaire answers
        </div>
      </BlurWrapper>
      <BlurWrapper
        blurKey={get(blurKeys, "mainBlurView")}
        overlayOpacityDefault="75"
        overlayColorDefault="dark"
        className="min-h-[100vh] h-full flex flex-col relative overflow-auto items-center"
      >
        <div className="flex flex-col p-6 w-full max-w-2xl mt-[10vh] gap-7 flex-1">
          {eventDetails?.eventDocData?.questionnaires?.map((question: any) => {
            if (!answersToQuestionnaire[question.order]) {
              return null
            }
            return (
              <div key={question.order}>
                <div className="text-white text-base font-medium text-left">
                  {question.question}
                </div>
                {question.questionType === QuestionType.TEXT && (
                  <div className="text-white text-base bg-white/10 p-4 rounded-lg text-left mt-2">
                    {answersToQuestionnaire[question.order]}
                  </div>
                )}

                {question.questionType === QuestionType.LONG_TEXT && (
                  <div className="text-white text-base bg-white/10 p-4 rounded-lg text-left mt-2 h-40 overflow-auto no-scrollbar">
                    {answersToQuestionnaire[question.order]}
                  </div>
                )}

                {question.questionType === QuestionType.SINGLE_SELECT && (
                  <div className="flex flex-col w-full bg-white/10 rounded-lg mt-2">
                    {question.options.map((item, index) => {
                      const answer = get(
                        answersToQuestionnaire,
                        question.order,
                        "",
                      )
                      const isActive =
                        get(item, "value", "")?.toLowerCase() ===
                        answer?.toLowerCase()

                      return (
                        <div key={index} className="w-full">
                          <div className="flex justify-between items-center px-4 py-2">
                            <div>
                              <p className="text-white text-base">
                                {item?.value}
                              </p>
                            </div>
                            <div onClick={() => {}} className="bg-transparent ">
                              {isActive ? (
                                <IoIosRadioButtonOn className="text-white text-xl" />
                              ) : (
                                <IoIosRadioButtonOff className="text-white text-xl" />
                              )}
                            </div>
                          </div>

                          {/* Optionally render a separator below each item */}
                        </div>
                      )
                    })}
                  </div>
                )}
                {question.questionType === QuestionType.MULTI_SELECT && (
                  <div className="flex flex-col w-full bg-white/10 rounded-lg mt-2">
                    {question.options.map((item, index) => {
                      const questionAnswer = get(
                        answersToQuestionnaire,
                        question.order,
                        [],
                      )?.map((answer) => answer?.toLowerCase())

                      const isActive = includes(
                        questionAnswer,
                        get(item, "value", null)?.toLowerCase(),
                      )

                      return (
                        <div key={index} className="w-full">
                          <div className="flex justify-between items-center px-4 py-2">
                            <div>
                              <p className="text-white text-base">
                                {item?.value}
                              </p>
                            </div>
                            <div onClick={() => {}} className="bg-transparent ">
                              {isActive ? (
                                <MdCheckBox className="text-white/70 text-2xl" />
                              ) : (
                                <MdCheckBoxOutlineBlank className="text-white/80 text-2xl" />
                              )}
                            </div>
                          </div>

                          {/* Optionally render a separator below each item */}
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </BlurWrapper>
    </BackgroundWrapper>
  )
}

export default ReviewQuestionnaire
